module.exports = __webpack_public_path__ + "static/media/profilenew.d8b405b3.svg";